import React from 'react';

import { AuctionInformationTooltipContainer } from './AuctionInformationTooltipContainer';
import { AuctionReduceBetModalContainer } from './AuctionReduceBetModalContainer';
import { PromotionDescriptionContainer } from './PromotionDescriptionContainer';
import { PublicationDateContainer } from './PublicationDateContainer';
import { VASListContainer } from './VASListContainer';
import { DoublesRankingPopupContainer } from '../DoublesRankingPopupContainer';

export function VASContainer() {
  return (
    <>
      <PublicationDateContainer />
      <VASListContainer />
      <PromotionDescriptionContainer />
      <AuctionInformationTooltipContainer />
      <AuctionReduceBetModalContainer />
      <DoublesRankingPopupContainer />
    </>
  );
}
